
import { Input, DatePicker, Select, Option } from "element-ui"
// import getCartNumMixin from "../mixins/getCartNum"
import { updateInfo, getUserInfo } from "@/api/authentication"
import { base64Decode } from "@/utils/utils"
import PersonalInformation from "@/components/PersonalInformation/index.vue"

export default {
  components: {
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    PersonalInformation
  },
  data() {
    return {
      options: [
        { label: "Male", value: 1 },
        { label: "Female", value: 2 }
      ],
      custId: "",
      form: {
        name: "",
        email: "",
        birth: "",
        gender: ""
      },
      changed: false,
      disabledBirth: false
    }
  },

  computed: {},
  watch: {},

  mounted() {
    const accountInfo = localStorage.getItem("accountInfo") ? base64Decode(localStorage.getItem("accountInfo")) : ""
    if (accountInfo && accountInfo.custId) {
      this.custId = accountInfo.custId
    }
    this.getUserInfo()
  },
  methods: {
    handleChanged(updatedFormData) {
      this.changed = true
      this.form = updatedFormData
    },
    async getUserInfo() {
      try {
        const res = await getUserInfo({
          custId: this.custId,
          loginChannel: 3
        })
        if (res.code == "0000" && res.data) {
          this.form.name = res.data.name
          this.form.email = res.data.email
          this.form.birth = res.data.birth
          this.form.gender = res.data.gender
          if (res.data.birth) {
            this.disabledBirth = true
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleUpdate() {
      if (!this.changed) return
      try {
        const res = await updateInfo({
          custId: this.custId,
          ...this.form,
          email: encodeURIComponent(this.form.email || ""),
          loginChannel: 3
        })
        if (res.code == "0000") {
          this.$message.success(this.$t("notification.operationSuccessful"))
          if (this.form.birth) {
            this.disabledBirth = true
          }
          setTimeout(() => {
            this.$store.dispatch("getLoginInfo")
          }, 2000)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
